import React from "react";
import Navbar from "./Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import hero_img02 from "../../image/iStock-693469160.jpg";
import download_img from "../../image/download_logo.jpg";
import s_s_img from "../../image/safe_secure.png";
import apk from "../../apk/Salarytp.apk";

function DownloadPage() {
  const navigate = useNavigate(); // Initialize the navigate hook

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = apk; // Use the imported APK file path
    link.download = "Salarytap.apk"; // The name of the file to be downloaded
    link.click();
  };
  return (
    <>
      <Navbar />

      <div className="container py-2">
        <div className="text-center mb-5">
          <h1 className="h3 fw-bold">
            How to <span className="text-danger">Install Salarytap App</span>
          </h1>
        </div>

        <div className="container">
          <div className="row">
            {/* Card 1 */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="card shadow-sm p-4">
                <div className="d-flex align-items-center mb-3">
                  <span className="h5 fw-bold me-3">1.</span>
                  <p className="mb-0">Tap 'OK' to download</p>
                </div>
                <div className="container mt-0">
                  <div
                    className="card p-4"
                    style={{
                      border: "1px solid ",
                    }}
                  >
                    <p className="text-center mb-4">
                      This type of file can harm your device.
                      <br />
                      Do you want to keep <strong>Salarytap.apk</strong> anyway?
                    </p>

                    <div className="d-flex justify-content-center">
                      <button
                        className="btn btn-outline-secondary mx-2"
                        onClick={() => navigate("/")}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary mx-2"
                        onClick={handleDownload}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="card shadow-sm p-4">
                <div className="d-flex align-items-center mb-3">
                  <span className="h5 fw-bold me-3">2.</span>
                  <p className="mb-0">
                    Open the downloaded file to start installing
                  </p>
                </div>
                <div className="container">
                  <div
                    className="rounded d-flex justify-content-between align-items-center p-3"
                    style={{
                      border: "1px solid black",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <i
                        className="bi bi-check-circle-fill text-success"
                        style={{ fontSize: "1.5rem" }}
                      ></i>
                      <p className="mb-0 ml-2">
                        <strong>Salarytap.apk</strong>
                        <a href="Salarytap://salarytap.in/salarytap/downloadpage">
                          {" "}
                          Open
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="card shadow-sm p-4">
                <div className="d-flex align-items-center mb-3">
                  <span className="h5 fw-bold me-3">3.</span>
                  <p className="mb-0">
                    Approve the installation of the app from unknown sources
                  </p>
                </div>
                <div
                  className="container p-4  rounded "
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <div className="mb-3">
                    <h5>&lt; Install unknown apps</h5>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    {/* App Icon */}
                    <img
                      src={download_img} // Replace with the actual SalaryTap logo path
                      alt="SalaryTap"
                      className="mr-3"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "8px",
                      }}
                    />

                    {/* App Name and Version */}
                    <div>
                      <h6>Salarytap</h6>
                      {/* <p className="text-muted mb-0">Version 1.0.0</p> */}
                    </div>
                  </div>

                  {/* Static Image of the Toggle Switch */}
                  <div className="d-flex justify-content-between align-items-center border shadow-md p-2 rounded rounded bg-light">
                    <span>Allow from this source</span>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={false}
                        readOnly // Makes the toggle static
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Download Issue Section */}
        <div className="mt-4 text-center">
          <p className="text-muted fs-4">
            Download didn’t work?{" "}
            <a
              onClick={handleDownload}
              className="text-primary text-decoration-underline"
            >
              Restart the download
            </a>
          </p>
        </div>

        {/* Safe and Secure Badge */}
        <div className="mt-5 d-flex justify-content-center align-items-center">
          <img
            src={s_s_img} // Replace with your security badge image
            alt="Safe and Secure"
            className="me-2"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "8px",
            }}
          />
          <p className="text-success fw-bold h5 mb-0">100% Safe and Secure</p>
        </div>
      </div>
      {/* <div>
        <div className="w-100">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div className="mt-2">
              <div
                id="carouselExampleCaptions"
                data-aos="fade-up"
                data-aos-duration="3500"
                className="carousel banner-height"
                data-ride="carousel"
                data-interval="3600"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "75vh",
                  margin: 0,
                  padding: 0, // Remove padding
                }}
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div
                      style={{
                        position: "relative",
                        backgroundColor: "black",
                        width: "100%",
                        height: "75vh",
                        margin: 0, // Remove margin
                        padding: 0, // Remove padding
                      }}
                    >
                      <div
                        className="custom-background"
                        style={{
                          position: "absolute",
                          backgroundColor: "#F5F5F5",
                          backgroundSize: "cover",
                          width: "100%",
                          height: "75vh",
                          display: "flex",
                          alignItems: "center", // Center vertically
                          justifyContent: "flex-start",
                          backgroundImage: `url(${hero_img02})`,
                          backgroundPosition: "center", // Center the background image
                          padding: "0 20px", // Padding for the container
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Optional shadow for depth
                        }}
                      >
                        <div
                          className="container d-flex flex-column"
                          style={{ gap: "20px", zIndex: 2 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src={download_img}
                              alt="Download Icon"
                              style={{
                                width: "55px",
                                height: "55px",
                                borderRadius: "8px",
                                marginTop: "5px",
                              }} // Adjust size as needed
                            />
                            <div
                              style={{
                                color: "white",
                                fontWeight: "500",
                                fontSize: "2.8rem",
                                marginLeft: "10px",
                                textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)", // Subtle shadow for depth
                              }}
                            >
                              Salarytap: Instant Salary
                            </div>
                          </div>
                          <div>
                            <a href={apk} download="Salarytap.apk">
                              <button
                                style={{
                                  padding: "14px 64px",
                                  fontSize: "1.1rem",
                                  fontWeight: "bold",
                                  color: "white",
                                  background:
                                    "linear-gradient(90deg, #007BFF, #0056b3)",
                                  border: "none",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  transition:
                                    "background-color 0.3s, transform 0.3s",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                                }}
                                onMouseOver={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(1.05)";
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                              >
                                Install
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          left: "0",
                          right: "0",
                          background: `
                linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 80%),
                linear-gradient(270deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%)
              `,
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                          zIndex: 1, // Make sure the gradient is behind the text
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: "40px" }}>
          <div className="container">
            <div
              className="h4 text-center"
              style={{
                backgroundColor: "#66a725",
                color: "#fff",
                padding: 4,
                borderTopLeftRadius: "0.375rem",
                borderTopRightRadius: "0.375rem",
              }}
            >
              About us
            </div>

            <div
              className="card bg-light"
              style={{
                padding: "30px",
                borderRadius: "10px",

                lineHeight: "1.8",
                color: "#444",

                fontSize: "1.1rem",
              }}
            >
              <div>
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Salarytap: Instant Salary
                </h2>
                <p>
                  Bridge the gap between paydays! Make every day your payday!
                  Cash on Demand.
                  <br />
                  Salarytap provides instant access to your next month's salary,
                  in advance. Instant transfer to your bank account.
                </p>
                <p style={{ fontStyle: "italic" }}>
                  Ease your financial worries with Salarytap now!
                </p>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Features: Salarytap - Instant Access to Your Next Month's
                  Salary
                </h3>
                <ul>
                  <li> Interest: 0%</li>
                  <li>Completely paperless process</li>
                  <li>
                    Minimal documentation - Just need your Aadhaar and PAN
                    number
                  </li>
                  <li>
                    Draw 24/7 during the month and pay on receipt of salary by
                    the 7th of the next month
                  </li>
                  <li>
                    Flexible repayment options through various payment methods
                  </li>
                  <li> Instant transfer of the amount to your bank account</li>
                  <li>Draw as little as Rs. 100 as per your need</li>
                  <li>
                    Repay at your convenience before the 7th of the next month
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Why Choose Salarytap over Other Digital Lending Apps:
                </h3>
                <ul>
                  <li>Interest-Free Credit Line</li>
                  <li>Quick Disbursal</li>
                  <li> Transparent Fees</li>
                  <li>Flexible Repayment</li>
                  <li> Convenient Access</li>
                  <li> Limit restored on repayment month on month</li>
                  <li> Pay only when you use the limit</li>
                  <li> Short-term credit</li>
                </ul>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Mandatory Requirements:
                </h3>
                <ul>
                  <li> Mobile number linked with Aadhaar and bank account</li>
                  <li>PAN linked to Aadhaar</li>
                  <li>
                    Willingness to share your bank account details through
                    Account Aggregator
                  </li>
                  <li>
                    3-month bank statement showing salary credited to your bank
                    account
                  </li>
                  <li>
                    Employed with the same employer for at least 3 months and a
                    total of 6 months overall
                  </li>
                </ul>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Eligibility:
                </h3>
                <ul>
                  <li>Salaried professionals above 21 years of age</li>
                  <li>Minimum net monthly salary: Rs. 10,000 </li>
                  <li>
                    Salary must be credited through direct bank transfer only
                  </li>
                  <li>
                    Valid documents required: PAN and Aadhaar number (or
                    alternate ID with identity and address proof)
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Unlock financial freedom between paychecks.
                </h3>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Sample Loan Calculation:
                </h3>
                <ul>
                  <li> Credit Line Amount: ₹5,000 </li>
                  <li>
                    Loan Duration: 12 Months (withdrawal amount needs to be
                    repaid monthly along with convenience fees){" "}
                  </li>
                  <li> Convenience Fees: 2%-4% on withdrawal</li>
                  <li> One-time Setup Fees: Rs. 300 (to be paid only once)</li>
                  <li> Interest: 0%</li>

                  <li> Total Convenience Fees: ₹200 </li>

                  <li>
                    Total Repayable Amount: ₹5,500 (withdrawal amount +
                    convenience fees + one-time setup fees){" "}
                  </li>
                  <li> APR (without one-time setup fees): 48% </li>
                  <li>First Month APR (with one-time setup fees): 120% </li>
                </ul>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Say goodbye to financial stress with Salarytap by your side.
                </h3>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Turn dreams into reality with Salarytap, your financial ally.
                </h3>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Customised Integration and Special Terms for Empanelled
                  Employer Employees:
                </h3>
                <ul>
                  <li>Straight through process </li>
                  <li>Higher limits </li>
                  <li>Lower costs </li>
                </ul>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Lending partner
                </h3>
                <ul>
                  <li>Capital Trust Limited </li>
                </ul>
              </div>
              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  To get started, visit our website:
                  <a href="http://www.salarytap.in" className="text-blue-600">
                    salarytap.in
                  </a>{" "}
                  and create a new workspace.
                </h3>
              </div>

              <div style={{ marginTop: "20px" }}>
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "#66a725",
                  }}
                >
                  Contact Us:
                </h3>
                <ul>
                  <li> Employees:</li>
                  <span>Helpline: Available in Salarytap App </span>
                </ul>
                <ul>
                  <li>Employers: </li>
                  <span>
                    Create your Workspace: on Salarytap.in and provide immediate
                    access for your Employees.{" "}
                  </span>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default DownloadPage;
